define('all/textKey',['jquery'], function($) {
	'use strict';

	function getTextValues(textKeyArray) {
		var result = '';
		$.ajax({
			type : 'POST',
			url : '/pp?flow=TextKeyJson',
			data : JSON.stringify(textKeyArray),
			dataType : 'json',
			contentType : 'application/json; charset=utf-8',
			async : false,
			success : function(data) {
				result = data;
			}
		});
		return result;
	}

	function readTextValues(textKeyArray, fn) {
		$.ajax({
			type : 'POST',
			url : '/pp?flow=TextKeyJson',
			data : JSON.stringify(textKeyArray),
			dataType : 'json',
			contentType : 'application/json; charset=utf-8',
			success : function(data) {
                fn = fn || $.noop;
				fn(data);
			}
		});
	}

    function getTexts(textKeyArray, fn) {
        readTextValues(textKeyArray, function(resultData) {
            addQuestionMarksToTextKeysNotFound(resultData, textKeyArray, fn);
        });
    }

    function addQuestionMarksToTextKeysNotFound(resultData, textKeyArray, fn) {
        for (var i = 0; i < textKeyArray.length; i++) {
            var textKey = textKeyArray[i];
            if( resultData[textKey] === undefined) {
                resultData[textKey] = '??' + textKey + '??';
            }
        }
        fn = fn || $.noop;
        fn(resultData);
    }

    var textKey = {
        getTextValues : getTextValues,
        readTextValues : readTextValues,
        getTexts: getTexts
    };

	window.textkey = textKey;

	return textKey;
});

